///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const FiltersIcon = ({
  title = messages.filters.defaultMessage,
  ...rest
}) => (
  <svg
    aria-labelledby="filters-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    {...rest}
  >
    <path
      fill="#0E1A28"
      fillRule="evenodd"
      d="M14.532 4.11c.432 0 .468-.346.468-.778 0-.43-.036-.778-.468-.778H8v1.557h6.532ZM1.468 2.558c-.429 0-.468.347-.468.778 0 .429.04.779.468.779H4.11V2.557H1.468ZM7.222 5.2V1.465c0-.429-.348-.465-.779-.465h-.778c-.431 0-.779.036-.779.465V5.2c0 .428.348.468.779.468h.778c.431 0 .779-.04.779-.468Zm-.779 9.332v-3.735c0-.428-.347-.465-.778-.465h-.779c-.43 0-.778.037-.778.465v3.735c0 .429.347.468.778.468h.779c.431 0 .778-.04.778-.468Zm3.89-4.2c.428 0 .778-.039.778-.467V6.132c0-.43-.347-.464-.779-.464h-.778c-.431 0-.778.036-.778.464v3.736c0 .428.347.467.778.467h.778v-.003Zm4.2-1.554c.43 0 .467-.347.467-.778 0-.431-.036-.778-.468-.778H11.89v1.556h2.643ZM1.467 7.222C1.039 7.222 1 7.569 1 8c0 .428.04.778.468.778H8V7.222H1.468Zm13.064 6.221c.432 0 .468-.347.468-.778 0-.431-.036-.779-.468-.779h-7.31v1.557h7.31ZM1.468 11.89c-.429 0-.468.347-.468.779 0 .428.04.778.468.778h1.864v-1.557H1.468Z"
      clipRule="evenodd"
    />
  </svg>
);

export default FiltersIcon;
